<template>
    <el-col
      :span="$vuetify.display.width >= 1500 ? 24 : 24"
      class="width-100-p p-2"
    >
      <div class="row m-0 p-2 bg-me-primary border-color-light rounded-4">
        <el-col style="align-content: center;" :span="24">
          <el-radio-group
            v-model="mapTheme"
            text-color="#ffff"
            fill="#234B49"
            :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
          >
            <el-radio-button
              class="start-period all-group-by text-center"
              label="light"
              :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            >
              {{
                "Light"
              }}
            </el-radio-button>
            <el-radio-button
              class="site-group-by text-center end-period"
              label="dark"
              :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            >
              Dark
            </el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col
          :span="24"
          class="mt-3 px-2"
          v-loading="loading"
          :element-loading-spinner="svg"
          element-loading-svg-view-box="-10, -10, 50, 50"
          element-loading-background="rgba(122, 122, 122, 0.8)"
        >
          <div
            :id="mapTheme == `light` ? `map` : `map-dark`"
            style="z-index: 1"
            :style="[
                  $vuetify.display.width >= 1500
                    ? { height: 635 + 'px' }
                    : $vuetify.display.width >= 500
                    ? { height: 600 + 'px' }
                    : { height: 340 + 'px' },
                ]"
          ></div>
  
          <div ref="popupContainer"></div>
        </el-col>
      </div>
    </el-col>
  </template>
  
  <script>
  import L from "leaflet";
  import "leaflet/dist/leaflet.css";
  import "leaflet.markercluster/dist/MarkerCluster.css";
  import "leaflet.markercluster/dist/MarkerCluster.Default.css";
  import "leaflet.markercluster";
  import PopupContent from "./showPopup";
  import { createApp } from "vue";
  import ElementPlus from "element-plus";

  
  export default {
    props: {
      chargerDistributionProp: {
        type: Array,
        default: null,
      },
      loadingProp: {
        type: Boolean,
        default: false,
      },
      stateProp: {
        type: String,
        default: null,
      },
      filterProp: {
        type: Object,
        default: null,
      },
      mapDataProp: {
        type: Object,
        default: null,
      },
   
    },
    components: {
      // eslint-disable-next-line vue/no-unused-components
      PopupContent,
    },
    watch: {
   
      filterProp: {
        handler: function (newVal) {
          this.customer_id = newVal.customer_id;
          this.state = newVal.state == "All" ? "" : newVal.state;
        },
        deep: true,
      },
      mapDataProp: {
        handler: function (newVal) {
            this.setMapData(newVal);
        },
        deep: true,
      },
    
    },
    data() {
      return {
        mapTheme: "light",
  
        loading: false,
        state: null,
        map: null,
        markerClusterGroup: null,
        mapOption: {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          zoom: 8,
          center: [-37.8136, 144.9631],
        },
        mapOptions: {
          scrollWheelZoom: false,
        },
        SiteDataList: [],
        popup: null,
        popupData: {},
        customer_id: null,
        circle: null,   // Circle layer
        // mapHeight: 400,
      };
    },
    mounted() {
      this.initMap();
    },
    methods: {
        setMapData(data){

          console.log("received data", data);
          
          this.SiteDataList = data.data;
          this.total_items = data.total_record;
          if (this.SiteDataList.length > 0) {
              this.mapOption.center = [
              this.SiteDataList[0].lat ? this.SiteDataList[0].lat : 0,
              this.SiteDataList[0].lng ? this.SiteDataList[0].lng : 0,
            ];
          }
          this.initMap();
          // this.addCircle(data.center_lat ? data.center_lat : 0, data.center_lng ? data.center_lng : 0, data.radius ? data.radius : 0, data.unit ? data.unit : 'kms'); 
        },
        addCircle(lat, lng, radius, unit) {
                if (this.circle) {
                    this.map.removeLayer(this.circle);  
                }
                if (unit == 'miles') {
                    radius = radius * 1.60934 * 1000; // Convert miles to kilometers
                } else {
                    radius = radius * 1000; // Convert kilometers to meters
                }

                // console.log("add circle", lat, lng, radius, unit);
                
                this.circle = L.circle([lat, lng], {
                    color: 'blue',
                    fillColor: '#30f',
                    fillOpacity: 0.1,
                    radius: radius, // Convert km to meters
                }).addTo(this.map);

                this.circle.bindPopup(`Center at (${lat}, ${lng}) with radius ${radius / 1000} ${unit} `);
            },
        initMap() {
            if (this.map) {
            this.map.remove();
            }
            this.map = L.map(this.mapTheme == 'light' ? "map" : "map-dark", {
            zoomControl: true,
            zoom: 1,
            zoomAnimation: false,
            fadeAnimation: true,
            markerZoomAnimation: true,
            }).setView(this.mapOption.center, this.mapOption.zoom);
            L.tileLayer(this.mapOption.url, {
            attribution: this.mapOption.attribution,
            }).addTo(this.map);
            this.markerClusterGroup = L.markerClusterGroup();
            this.addMarkers();
            this.map.addLayer(this.markerClusterGroup);
            
        },

        addMarkers() {
            this.SiteDataList.forEach((item) => {
            if (item.lat == null) item.lat = 0;
            if (item.lng == null) item.lng = 0;
    
            L.marker([item.lat, item.lng],{icon: this.getCustomIcon(item.emission_intensity)})
                .on("click", (e) => this.showPopup(e, item))
                .addTo(this.markerClusterGroup);
            });
        },

        getCustomIcon(value) {
          const color = this.getColorFromValue(value);
          return L.icon({
            iconUrl: this.getIconUrl(color),
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowUrl:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
            shadowSize: [41, 41],
            shadowAnchor: [12, 41],
          });
        },
        getIconUrl(color) {
          const markerSvg = 
          `<svg width="31" height="43" viewBox="0 0 31 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2200_5329)">
          <path d="M15.4999 8.44043C11.5599 8.44043 8.35986 11.6804 8.35986 15.6404C8.35986 19.6104 11.5599 22.8404 15.4999 22.8404C19.4399 22.8404 22.6399 19.6004 22.6399 15.6404C22.6399 11.6804 19.4399 8.44043 15.4999 8.44043Z" fill="white"/>
          <path d="M15.5 0.5C23.77 0.5 30.5 7.29 30.5 15.65C30.5 18.15 29.88 20.63 28.72 22.81L15.5 42.12L2.28 22.81C1.11 20.62 0.5 18.14 0.5 15.64C0.5 7.29 7.23 0.5 15.5 0.5ZM15.5 8.44C11.56 8.44 8.36 11.68 8.36 15.64C8.36 19.61 11.56 22.84 15.5 22.84C19.44 22.84 22.64 19.6 22.64 15.64C22.64 11.68 19.44 8.44 15.5 8.44Z" fill="${color}" stroke="white"/>
          </g>
          <defs>
          <clipPath id="clip0_2200_5329">
          <rect width="31" height="43" fill="white"/>
          </clipPath>
          </defs>
          </svg>`;
          return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
            markerSvg
          )}`;
        },
        getColorFromValue(value) {
          let r, g, b;

          if (value <= 0.03) {
            // Level 4
            r = 3;
            g = 125;
            b = 164;
          } else if (value <= 0.045) {
            // Level 4
            r = 79;
            g = 153;
            b = 220;
          } else if (value <= 0.064) {
            // Level 4
            r = 112;
            g = 187;
            b = 211;
          } else if (value <= 0.1) {
            // Level 4
            r = 218;
            g = 255;
            b = 123;
          } else if (value <= 0.2) {
            // Level 4
            r = 244;
            g = 215;
            b = 97;
          } else if (value <= 0.4) {
            // Level 4
            r = 229;
            g = 160;
            b = 57;
          } else if (value <= 0.5) {
            // Level 4
            r = 231;
            g = 59;
            b = 48;
          } else if (value <= 0.65) {
            // Level 4
            r = 120;
            g = 190;
            b = 32;
          } else {
            // For values > 4
            r = 20;
            g = 96;
            b = 84;
          }

          return `rgb(${r},${g},${b})`;
        },
  
        showPopup(e, marker) {
            if (this.popup) {
            this.popup.remove();
            }

            this.popupData = marker;
            // console.log("popupData", this.popupData);
            
            const popupContainer = document.createElement("div");
            const appInstance = createApp(PopupContent, {
            popupData: this.popupData,
            }).use(ElementPlus);
            appInstance.mount(popupContainer);
            this.map.flyTo(e.latlng, this.map.getZoom());
            this.popup = L.popup()
            .setLatLng(e.latlng)
            .setContent(popupContainer)
            .openOn(this.map);
        },
  
    },
  };
  </script>
  
  
  